var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[(!_vm.loggedIn)?_c('LoginPanel',{on:{"login":function($event){return _vm.onLogin($event)}}}):_c('MainView',{attrs:{"client":_vm.client}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }